import React from "react";
import Typography from "@mui/material/Typography";
import darkTheme from '../../src/theme';
import {nanoid} from 'nanoid'

const lineUpCard = {
    paddingTop: darkTheme.spacing(1),
    marginBottom: darkTheme.spacing(1),
   '& h5': {
        fontSize: 14,
        textTransform: 'capitalize',    
        color: darkTheme.palette.primary.dates,       
       fontWeight: 400,
        marginBottom: darkTheme.spacing(1)
    },    
    '& h6': {
        fontSize: 14,
        color: darkTheme.palette.primary.title,
        textTransform: 'capitalize !important',
        border: `1px solid #3F3E46`,
        backgroundColor: darkTheme.palette.background.default,
        display: 'inline-block',        
        padding: '8px 16px',
        borderRadius: 1.5,
        marginRight: 1,
        textAlign: 'center',
        fontWeight: 400,
        marginBottom: 1,
        [darkTheme.breakpoints.down("md")]: {
            padding: '6px 12px',
        }
                
    },
    [darkTheme.breakpoints.down("md")]: {
        marginTop: darkTheme.spacing(2),
        paddingTop: darkTheme.spacing(2),
        borderTop: `1px solid`,
        borderColor: darkTheme.palette.grey[900],
    }
};

function LineUp({data}) {      
  return (
      <>
          {data.event_artists.length > 0 ? (
              <Typography component="div" sx={lineUpCard}>
                  <Typography variant="h5">Line Up</Typography>
                  {data.event_artists.split(",").map((step, i) => (
                      <Typography variant="h6" key={nanoid(30)}>
                          {step.toLowerCase()}
                          {"\n"}
                      </Typography>
                  ))}
              </Typography>
          ) : ('')}  
    </>
  );
}

export default LineUp;




                            